module.exports = __webpack_public_path__ + "static/img/12.26bec63.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/zh/12.png
// module id = cwXe
// module chunks = 0